import React from "react";
import { AlertCircle, RefreshCw } from "lucide-react";
import { Button } from "@src/lib/ui/Button";
import Text from "@src/lib/ui/Text";
import { cn } from "@src/lib/utils/cn";

interface OpusAgentErrorBubbleProps {
  message?: string;
  onRetry?: () => void;
  className?: string;
}

// Styling duplicated from the Ask Opus ChatErrorMessage.
export const OpusAgentErrorBubble: React.FC<OpusAgentErrorBubbleProps> = ({
  message,
  onRetry,
  className = "",
}) => {
  return (
    <div className={cn("my-2 w-full", className)}>
      <div className="flex items-center justify-center gap-3 rounded-lg border border-red-3 bg-red-1 p-4">
        <div className="flex-shrink-0">
          <AlertCircle className="h-5 w-5 text-red-7" />
        </div>
        <div className="flex min-w-0 flex-1 items-center justify-between gap-4">
          <div>
            <div>
              <Text variant="compact-title" className="mb-1 text-red-9">
                Error
              </Text>
            </div>
            <div>
              <Text
                variant="fine-print-description"
                multiline
                className="mb-3 text-red-8"
              >
                {message ||
                  "Something went wrong with the AI response. Please try again."}
              </Text>
            </div>
          </div>
          {onRetry && (
            <Button variant="destructive" size="sm" onClick={onRetry}>
              <RefreshCw data-icon="inline-start" />
              Try again
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
